<template>
  <b-form-group :label="label" :description="description" class="mb-3">
    <div v-if="isSet && !editing" class="d-flex align-items-center">
      <span class="text-muted mr-3">ตั้งค่าแล้ว ••••</span>
      <b-button v-if="canEdit" size="sm" variant="outline-secondary" @click="startEdit">เปลี่ยน</b-button>
    </div>
    <template v-else>
      <b-form-textarea v-if="multiline" :value="value" rows="3" :disabled="!canEdit" :placeholder="placeholder"
        autocomplete="off" @input="$emit('input', $event)" />
      <b-form-input v-else :value="value" :type="secret ? 'password' : 'text'" :disabled="!canEdit"
        :placeholder="placeholder" autocomplete="off" @input="$emit('input', $event)" />
      <small v-if="error" class="text-danger">{{ error }}</small>
    </template>
  </b-form-group>
</template>

<script>
export default {
  name: "LineCredentialField",
  props: {
    label: { type: String, required: true },
    description: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    value: { type: String, default: "" },
    isSet: { type: Boolean, default: false },
    secret: { type: Boolean, default: true },
    multiline: { type: Boolean, default: false },
    canEdit: { type: Boolean, default: false },
    error: { type: String, default: "" },
  },
  data() {
    return { editing: false };
  },
  watch: {
    isSet() {
      this.editing = false;
    },
  },
  methods: {
    startEdit() {
      this.editing = true;
      this.$emit("input", "");
    },
  },
};
</script>
